import { StyleSheet, View } from 'react-native';
import { Text, theme } from '@socrait/react';

import { useOutageBannerMessage } from '~/featureFlags';

export function OutageBanner() {
  const message = useOutageBannerMessage();
  if (!message) return null;

  return (
    <View style={styles.container}>
      <Text style={styles.text}>
        <Text style={styles.prefix}>Service notice:</Text> {message}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    backgroundColor: theme.colors.cautionBg,
    paddingHorizontal: theme.spacing.large,
    paddingVertical: theme.spacing.small,
  },
  text: {
    color: theme.colors.black,
    fontSize: theme.fontSizes.small,
    lineHeight: theme.lineHeights.small,
    textAlign: 'center',
  },
  prefix: {
    fontSize: theme.fontSizes.small,
    fontWeight: theme.fontWeights.bold,
  },
});
